import { render, staticRenderFns } from "./page4-xiyatu.vue?vue&type=template&id=02f82412&scoped=true"
import script from "./page4-xiyatu.vue?vue&type=script&lang=js"
export * from "./page4-xiyatu.vue?vue&type=script&lang=js"
import style0 from "./page4-xiyatu.vue?vue&type=style&index=0&id=02f82412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f82412",
  null
  
)

export default component.exports